import React from 'react';
import '../styles/BackgroundAnimation.css';

const BackgroundAnimation: React.FC = () => {
  return (
    <div className="background-animation">
      <div className="chart-elements">
        {Array.from({ length: 15 }).map((_, index) => (
          <div key={index} className={`chart-element chart-${index % 5}`}>
            <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
              {index % 5 === 0 && (
                // Bar chart
                <>
                  <rect x="20" y="70" width="10" height="20" />
                  <rect x="45" y="50" width="10" height="40" />
                  <rect x="70" y="30" width="10" height="60" />
                </>
              )}
              {index % 5 === 1 && (
                // Line chart
                <path d="M10 70 L30 40 L50 60 L70 30 L90 50" strokeWidth="2" stroke="currentColor" fill="none" />
              )}
              {index % 5 === 2 && (
                // Pie chart
                <path d="M50 50 L50 20 A30 30 0 0 1 76 65 Z" />
              )}
              {index % 5 === 3 && (
                // Scatter plot
                <>
                  <circle cx="30" cy="40" r="3" />
                  <circle cx="45" cy="60" r="3" />
                  <circle cx="60" cy="35" r="3" />
                  <circle cx="75" cy="55" r="3" />
                </>
              )}
              {index % 5 === 4 && (
                // Area chart
                <path d="M10 70 L30 40 L50 60 L70 30 L90 50 L90 90 L10 90 Z" fillOpacity="0.2" />
              )}
            </svg>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BackgroundAnimation;
